import { getSegmentId } from './segment';

export const TRACKER_PAGE_VIEW_CONFIG = {
  event_type: 'view',
  event_type_version: '1',
};

export const trackPageView = async ({ referrer }) => {
  fetch('https://www.pathrise.com/t', {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...TRACKER_PAGE_VIEW_CONFIG,
      url: window.location.href,
      created_at: new Date(),
      segment_id: await getSegmentId(),
      referrer,
    }),
  });
};
